import React from "react";

// Mui
import ImageZoom from "@/components/imageZoom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import IconButton from "@mui/material/IconButton";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import "../styles/components/zoomFullScreen.css";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

// Config

const ExchangeInvoiceDataRow = (props) => {
  const { data, handleChecked } = props;

  // States
  const [open, setOpen] = React.useState(true);
  const [isZoomFullScreenOpen, setZoomFullScreenOpen] = React.useState(false);
  const [photoSource, setPhotoSource] = React.useState("");

  //turn on ZoomFullScreen and store uri soure into state
  const handleClickOpen = (src) => {
    setPhotoSource(src);
    setZoomFullScreenOpen(true);
  };

  // turn off ZoomFullScreen
  const handleClose = () => {
    setZoomFullScreenOpen(false);
  };

  return (
    <TableBody>
      <TableRow>
        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
        >
          {data.alias}
        </TableCell>

        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
        >
          {data.work_shortcode}
        </TableCell>

        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
        >
          {data.reason}
        </TableCell>

        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
          colSpan={3}
        ></TableCell>

        <TableCell
          align="center"
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
        >
          {moment(data.time_created).format("YYYY-MM-DD HH:mm:ss")}
        </TableCell>

        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
          colSpan={1}
        ></TableCell>

        <TableCell
          sx={{
            backgroundColor: open ? "#e8ebee" : "white",
          }}
        >
          <IconButton size="small" onClick={() => setOpen((prev) => !prev)}>
            {!open ? (
              <ArrowDropDownIcon fontSize="inherit" />
            ) : (
              <ArrowDropUpIcon fontSize="inherit" />
            )}
          </IconButton>
        </TableCell>
      </TableRow>
      {open && (
        <>
          {data.item.length > 0 &&
            data.item.map((item, itemIndex) => (
              <DataCell
                key={itemIndex}
                item={item}
                open={open}
                itemNo={itemIndex + 1}
              />
            ))}
        </>
      )}
      <TableRow>
        <TableCell
          colSpan={9}
          sx={{
            // backgroundColor: open ? "#f4f6f8" : "white",
            backgroundColor: "white",
          }}
        >
          {data.attachments && (
            <ImageZoom attachments={data.attachments}></ImageZoom>
          )}
        </TableCell>
      </TableRow>
    </TableBody>
  );

  function DataCell(props) {
    const { open, item, itemNo } = props;

    return (
      <TableRow>
        <TableCell
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        >
          {itemNo}.
        </TableCell>
        <TableCell
          colSpan={2}
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        ></TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        >
          {item.item}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        >
          {item.exchange_qty < 0 ? "出" : "進"}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        >
          {Math.abs(item.exchange_qty) * 1}
        </TableCell>

        <TableCell
          align="center"
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        >
          {moment(item.time_created).format("YYYY-MM-DD HH:mm:ss")}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        >
          {/* <Button
              variant={item.is_checked ? "contained" : "outlined"}
              color={item.is_checked ? "success" : "info"}
              size="small"
              onClick={() => handleChecked(data)}
            >
              {item.is_checked === false ? "未檢查" : "已檢查"}
            </Button> */}
        </TableCell>
        <TableCell
          sx={{
            backgroundColor: open ? "#f4f6f8" : "white",
          }}
        ></TableCell>
      </TableRow>
    );
  }
};

export default ExchangeInvoiceDataRow;
